(()=>{
    let eBand = document.getElementById("band")
    let eCup = document.getElementById("cup")
    // let eLabel = document.getElementById("label")
    let eSize = document.getElementById("size")

    const SIZES = {
        size1: 'Size 1',
        size2: 'Size 2',
        size3: 'Size 3',
        size4: 'Size 4',
        size5: 'Size 5',
        NA: 'Coming Soon! - Sign up for notifications',
    }

    function getSize(band, cup){
        if (band >= 28 && band <= 30 && ['A', 'B', 'C', 'D', 'DD', 'DDD', 'E', 'F', 'G', 'H'].includes(cup)) {
            return SIZES.size1
        }
        if (band >= 30.5 && band <= 31.5 && ['A', 'B', 'C', 'D', 'DD', 'DDD', 'E'].includes(cup)) {
            return SIZES.size1
        }
        if (band >= 32 && band <= 36.5 && ['A', 'B', 'C', 'D', 'DD', 'DDD', 'E', 'F', 'G', 'H'].includes(cup)) {
            return SIZES.size2
        }
        if (band >= 37 && band <= 41.5 && ['A', 'B', 'C', 'D', 'DD', 'DDD', 'E', 'F', 'G', 'H'].includes(cup)) {
            return SIZES.size3
        }
        if (band >= 42 && band <= 43.5 && ['A', 'B', 'C', 'D', 'DD', 'DDD', 'E', 'F', 'G', 'H'].includes(cup)) {
            return SIZES.size4
        }
        if (band >= 44 && band <= 48 && ['A', 'B', 'C', 'D', 'DD', 'DDD', 'E', 'F', 'G', 'H'].includes(cup)) {
            return SIZES.size5
        }
        if (band >= 48.5 && band <= 50 && ['A', 'B', 'C', 'D', 'DD', 'DDD', 'E', 'F', 'G', 'H'].includes(cup)) {
            return SIZES.NA
        }
        if (band >= 28 && band <= 50 && ['I'].includes(cup)) {
            return SIZES.NA
        }
        if (band >= 30.5 && band <= 31.5 && ['F', 'G', 'H'].includes(cup)) {
            return SIZES.NA
        }
        if (band >= 28 && band <= 30 && cup - band >= 1 && cup - band <= 8) {
            return SIZES.size1
        }
        if (band >= 30.5 && band <= 31.5 && cup - band >= 1 && cup - band <= 6) {
            return SIZES.size1
        }
        if (band >= 32 && band <= 36.5 && cup - band >= 1 && cup - band <= 8) {
            return SIZES.size2
        }
        if (band >= 37 && band <= 41.5 && cup - band >= 1 && cup - band <= 8) {
            return SIZES.size3
        }
        if (band >= 42 && band <= 43.5 && cup - band >= 1 && cup - band <= 8) {
            return SIZES.size4
        }
        if (band >= 44 && band <= 48 && cup - band >= 1 && cup - band <= 8) {
            return SIZES.size5
        }
        if (band >= 30.5 && band <= 31.5 && cup - band >= 7 && cup - band <= 8) {
            return SIZES.NA
        }
        if (band >= 48.5 && band <= 50 && cup - band >= 1 && cup - band <= 8) {
            return SIZES.NA
        }
        if (band >= 28 && band <= 50 && cup - band === 9) {
            return SIZES.NA
        } else return "Your MINDD Size"
    }

    function setCupRange(eCup, eBand){
        // if (eLabel.value === 'INCHES') {
        //     let band = (eBand.value === 'Band') ? 28 : eBand.value
        //     let minCup = +band + 1
        //     let arrCup = []
        //     for (let i = 0; i < 9; i++) {
        //         arrCup.push(minCup + i)
        //     }
        //     let cupRange = document.getElementById('cup').options
        //     cupRange.length = 0
        //     cupRange[0] = new Option('Cup', 'Cup')
        //     for (let i = 0; i < 9; i++) {
        //         cupRange[i + 1] = new Option(arrCup[i], arrCup[i])
        //     }
        // } else {
            const initCup = ['Cup', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'E', 'F', 'G', 'H', 'I']
            eCup.innerHTML = initCup.map(i => `<option value=${i}>${i}</option>`).join('')
        // }
    }

    function recalculateSize(eBand, eCup, eSize){
        //get current values from eband and ecup
        let band = eBand.value;
        let cup = eCup.value;
        //check if all parameters are selected, return false
        if (band !== 'Band' && cup !== 'Cup') {
            let size = getSize(band, cup)
            eSize.value = size;
        }
    }

    function resetSize(eSize) {        
        eSize.value = 'Your MINDD Size'
    }
  
    function resetBandCup(eBand, eCup, eSize) {
        eBand.value = 'Band'
        eCup.value = 'Cup'
        eSize.value = 'Your MINDD Size'
    }
       
    const checkGuideInterval = setInterval(() => {
      const guide = document.querySelector('.ks-chart-container');      
      // const hr = document.querySelector('.product-block hr');
      //   const sizeChart = document.querySelector('._ks_text');
      if (guide) {
        clearInterval(checkGuideInterval);
        // sizeChart.textContent = 'Size Guide';
        guide.style.display = 'block';        
        // hr.insertAdjacentElement('afterend', guide)
        // document.body.classList.remove('body-visible');
      }
    }, 500);

const videoLink = document.querySelector('.video-link');
const videoPopup = document.querySelector('.video-popup');
const popupVideo = document.getElementById('popup-video');
const closeBtn = document.querySelector('.close-btn');

videoLink.addEventListener('click', function(e) {
  e.preventDefault();
  videoPopup.style.display = 'block';
  popupVideo.play();
});

function closePopup() {
  videoPopup.style.display = 'none';
  popupVideo.pause();
}

videoPopup.addEventListener('click', function(e) {
  if (e.target === this) {
    closePopup();
  }
});

closeBtn.addEventListener('click', closePopup);  
  
    eBand.addEventListener('change', function(ev){
        setCupRange(eCup, eBand);
        recalculateSize(eBand, eCup);
        resetSize(eSize)
    });

    eCup.addEventListener('change', function(ev){
        recalculateSize(eBand, eCup, eSize);

    let size = 0
    if (eSize.value === 'Size 1') {size = 1}
    if (eSize.value === 'Size 2') {size = 2}
    if (eSize.value === 'Size 3') {size = 3}
    if (eSize.value === 'Size 4') {size = 4}
    if (eSize.value === 'Size 5') {size = 5}  
    const input1 = document.querySelector('input[value="' + size + '"]')
    input1?.click()    
    });

    // eLabel.addEventListener('change', function(ev){
    //     setCupRange(eCup, eBand);
    //     recalculateSize(eBand, eCup, eSize);
    // });

    eSize.addEventListener('change', function(ev){
        resetBandCup(eBand, eCup, eSize)
    })
})()